import eventCards from './eventCards';
import manualEventFeed from './manualEventFeed';
import parallaxEffect from './parallaxEffect';

export default async function renderEventsSection() {
  const [hasEventCards, hasManualEvents] = await Promise.all([eventCards(), manualEventFeed()]);

  if (hasEventCards || hasManualEvents) {
    parallaxEffect();
  }
}
